/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import { BOTAO_VOLTAR } from '../../constantsCancelarAssinatura'
import Link from '../../../../../../components/Link/Link'

const estiloDoisBotoes = `
  &:first-of-type {
    margin-right: 15px;
  }
`

const estiloDoisBotoesMobile = `
  &:first-of-type {
    margin-right: 0px;
    margin-bottom: 10px;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 5px 0 0;
    justify-content: center;

    a {
      width: 100%;
    }
  }

  button {
    background-color:${StyleGuide.cores.branco};
    ${( { hasMargin } ) => hasMargin && estiloDoisBotoes};

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 16px;
      margin-bottom: 0px;
      ${( { hasMargin } ) => hasMargin && estiloDoisBotoesMobile};
    }
  }
`

const Navegacao = ( {
  botaoContinuarDesabilitado,
  eventoBotaoContinuar,
  eventoBotaoVoltar,
  hasMargin,
  tituloContinuar,
  tituloVoltar,
  urlParaContinuar,
  urlParaVoltar,
  testIdName
} ) => {
  return (
    <ButtonsWrapper hasMargin={ Boolean( urlParaVoltar ) || hasMargin }>
      {( eventoBotaoVoltar || urlParaVoltar ) ?
        <Fragment>
          {urlParaVoltar ? (
            <Link to={ urlParaVoltar }>
              <Button
                className="button__cancelar"
                invertido
                onClick={ () => eventoBotaoVoltar && eventoBotaoVoltar() }
                tema={ Button.BOTAO_CURADORIA }
                testId="seguir-cancelamento3"
              >
                {tituloVoltar || BOTAO_VOLTAR}
              </Button>
            </Link>
          ) : (
            <Button
              className="button__cancelar"
              invertido
              onClick={ () => eventoBotaoVoltar && eventoBotaoVoltar() }
              tema={ Button.BOTAO_CURADORIA }
              testId="seguir-cancelamento3"
            >
              {tituloVoltar || BOTAO_VOLTAR}
            </Button>
          )}
        </Fragment> : null}

      {( eventoBotaoContinuar || urlParaContinuar ) ?
        <Fragment>
          {urlParaContinuar ? (
            <Link to={ urlParaContinuar }>
              <Button
                disabled={ botaoContinuarDesabilitado }
                onClick={ () => eventoBotaoContinuar && eventoBotaoContinuar() }
                tema={ Button.BOTAO_CURADORIA }
                testId={ testIdName }
              >
                {tituloContinuar}
              </Button>
            </Link>
          ) : (
            <Button
              disabled={ botaoContinuarDesabilitado }
              onClick={ () => eventoBotaoContinuar && eventoBotaoContinuar() }
              tema={ Button.BOTAO_CURADORIA }
              testId={ testIdName }
            >
              {tituloContinuar}
            </Button>
          )}
        </Fragment> : null}
    </ButtonsWrapper>
  )
}

Navegacao.defaultProps = {
  'botaoContinuarDesabilitado': false,
  'eventoBotaoContinuar': null,
  'eventoBotaoVoltar': null,
  'hasMargin': false,
  'tituloVoltar': null,
  'urlParaContinuar': null,
  'urlParaVoltar': null
}

Navegacao.propTypes = {
  'botaoContinuarDesabilitado': bool,
  'eventoBotaoContinuar': func,
  'eventoBotaoVoltar': func,
  'hasMargin': bool,
  'tituloContinuar': string.isRequired,
  'tituloVoltar': string,
  'urlParaContinuar': string,
  'urlParaVoltar': string,
  'testIdName': string.isRequired,
}

export default Navegacao
